import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box,
  Button
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { alpha } from '@mui/material/styles';
import FinancialBudget from './financialBudget';

const FinancialTable = () => {
  const navigate = useNavigate();
  const initialRows = [
    { 
      id: 'isletme', 
      label: 'İŞLETME GİDERLERİ', 
      values: [0, 0, 0, 0, 0], 
      isTotal: true,
      totalFrom: ['personel', 'iletisim', 'enerji', 'ofis', 'seyahat', 'temsil', 'kira', 'reklam', 'musavirlik', 'uretim', 'temizlik', 'diger'] 
    },
    { 
      id: 'personel', 
      label: 'PERSONEL GİDERLERİ', 
      values: [0, 0, 0, 0, 0], 
      isTotal: true,
      totalFrom: ['yonetici', 'personelUcret', 'sgk', 'bagkur', 'yemek', 'digerPersonel'] 
    },
    { id: 'yonetici', label: 'Yönetici Ücretleri', values: [0, 0, 0, 0, 0] },
    { id: 'personelUcret', label: 'Personel Ücretleri', values: [0, 0, 0, 0, 0] },
    { id: 'sgk', label: 'SGK & Stopaj', values: [0, 0, 0, 0, 0] },
    { id: 'bagkur', label: 'BAĞKUR', values: [0, 0, 0, 0, 0] },
    { id: 'yemek', label: 'Yemek', values: [0, 0, 0, 0, 0] },
    { id: 'digerPersonel', label: 'Diğer', values: [0, 0, 0, 0, 0] },
    
    { 
      id: 'iletisim', 
      label: 'İLETİŞİM/HABERLEŞME GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['telefon', 'internet', 'cepTelefonu', 'server', 'digerIletisim']
    },
    { id: 'telefon', label: 'Telefon', values: [0, 0, 0, 0, 0] },
    { id: 'internet', label: 'Internet', values: [0, 0, 0, 0, 0] },
    { id: 'cepTelefonu', label: 'Cep Telefonu', values: [0, 0, 0, 0, 0] },
    { id: 'server', label: 'Server', values: [0, 0, 0, 0, 0] },
    { id: 'digerIletisim', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'enerji', 
      label: 'ENERJİ/SU/DİĞER GİDERLER', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['elektrik', 'su', 'tesisat', 'digerEnerji']
    },
    { id: 'elektrik', label: 'Elektrik', values: [0, 0, 0, 0, 0] },
    { id: 'su', label: 'Su', values: [0, 0, 0, 0, 0] },
    { id: 'tesisat', label: 'Tesisat bakım onarım', values: [0, 0, 0, 0, 0] },
    { id: 'digerEnerji', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'ofis', 
      label: 'OFİS GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['sarf', 'fotokopi', 'digerOfis']
    },
    { id: 'sarf', label: 'Sarf Malzeme', values: [0, 0, 0, 0, 0] },
    { id: 'fotokopi', label: 'Fotokopi/Kırtasiye', values: [0, 0, 0, 0, 0] },
    { id: 'digerOfis', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'seyahat', 
      label: 'SEYAHAT GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['aracKira', 'konaklama', 'ulasim', 'digerSeyahat']
    },
    { id: 'aracKira', label: 'Araç Kira', values: [0, 0, 0, 0, 0] },
    { id: 'konaklama', label: 'Konaklama', values: [0, 0, 0, 0, 0] },
    { id: 'ulasim', label: 'Ulaşım/Seyahat', values: [0, 0, 0, 0, 0] },
    { id: 'digerSeyahat', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'temsil', 
      label: 'TEMSİL GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['hediye', 'esantiyon', 'digerTemsil']
    },
    { id: 'hediye', label: 'Hediye', values: [0, 0, 0, 0, 0] },
    { id: 'esantiyon', label: 'Eşantiyon', values: [0, 0, 0, 0, 0] },
    { id: 'digerTemsil', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'kira', 
      label: 'KİRA GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['isyeriKira', 'aidat', 'stopaj', 'isyeriSigortasi', 'digerKira']
    },
    { id: 'isyeriKira', label: 'İşyeri Kira', values: [0, 0, 0, 0, 0] },
    { id: 'aidat', label: 'Aidat', values: [0, 0, 0, 0, 0] },
    { id: 'stopaj', label: 'Stopaj', values: [0, 0, 0, 0, 0] },
    { id: 'isyeriSigortasi', label: 'İşyeri Sigortası', values: [0, 0, 0, 0, 0] },
    { id: 'digerKira', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'reklam', 
      label: 'REKLAM GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['kartvizit', 'brosur', 'sosyalMedya', 'webSayfasi', 'fuar', 'tvRadyo', 'digerReklam']
    },
    { id: 'kartvizit', label: 'Kartvizit', values: [0, 0, 0, 0, 0] },
    { id: 'brosur', label: 'Broşür-Katalog', values: [0, 0, 0, 0, 0] },
    { id: 'sosyalMedya', label: 'Sosyal Medya', values: [0, 0, 0, 0, 0] },
    { id: 'webSayfasi', label: 'Web Sayfası/portallar', values: [0, 0, 0, 0, 0] },
    { id: 'fuar', label: 'Fuar Katılımları', values: [0, 0, 0, 0, 0] },
    { id: 'tvRadyo', label: 'TV/Radyo/diğer', values: [0, 0, 0, 0, 0] },
    { id: 'digerReklam', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'musavirlik', 
      label: 'MÜŞAVİRLİK GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['mali', 'hukuk', 'digerMusavirlik']
    },
    { id: 'mali', label: 'Mali Müşavirlik/Muhasebe', values: [0, 0, 0, 0, 0] },
    { id: 'hukuk', label: 'Hukuk Müşavirliği', values: [0, 0, 0, 0, 0] },
    { id: 'digerMusavirlik', label: 'Diğer', values: [0, 0, 0, 0, 0] },

    { 
      id: 'uretim', 
      label: 'ÜRETİM', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['arge', 'danismanlik', 'lisans', 'patent', 'demirbas', 'ekipman', 'finansman']
    },
    { id: 'arge', label: 'AR-GE', values: [0, 0, 0, 0, 0] },
    { id: 'danismanlik', label: 'Danışmanlık', values: [0, 0, 0, 0, 0] },
    { id: 'lisans', label: 'Lisans', values: [0, 0, 0, 0, 0] },
    { id: 'patent', label: 'Patent', values: [0, 0, 0, 0, 0] },
    { id: 'demirbas', label: 'Demirbaş', values: [0, 0, 0, 0, 0] },
    { id: 'ekipman', label: 'Ekipman', values: [0, 0, 0, 0, 0] },
    { id: 'finansman', label: 'Finansman', values: [0, 0, 0, 0, 0] },

    { 
      id: 'temizlik', 
      label: 'TEMİZLİK GİDERLERİ', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['temizlikAlt']
    },
    { id: 'temizlikAlt', label: 'Temizlik', values: [0, 0, 0, 0, 0] },

    { 
      id: 'diger', 
      label: 'ÖNGÖRÜLEMEYEN GİDERLER', 
      values: [0, 0, 0, 0, 0],
      isTotal: true,
      totalFrom: ['digerGiderler']
    },
    { id: 'digerGiderler', label: 'Diğer Giderler', values: [0, 0, 0, 0, 0] },
  ];

  const [rows, setRows] = useState(initialRows);

  const handleValueChange = (rowIndex, colIndex, value) => {
    const newValue = value === '' ? 0 : parseFloat(value) || 0;
    const newRows = [...rows];
    newRows[rowIndex].values[colIndex] = newValue;
    
    // Toplam satırları güncelle
    newRows.forEach((row, index) => {
      if (row.isTotal) {
        row.values = row.values.map((_, valIndex) => {
          return calculateTotalForGroup(row.totalFrom, valIndex, newRows);
        });
      }
    });
    
    setRows(newRows);
  };

  const calculateTotalForGroup = (groupIds, colIndex, currentRows) => {
    return groupIds.reduce((total, id) => {
      const row = currentRows.find(r => r.id === id);
      return total + (row ? row.values[colIndex] : 0);
    }, 0);
  };

  const calculateRowTotal = (values) => {
    return values.reduce((acc, curr) => acc + curr, 0);
  };

  const calculateColumnTotal = (colIndex) => {
    return rows.reduce((acc, row) => acc + row.values[colIndex], 0);
  };

  const handleSaveAndContinue = () => {
    // Burada gerekli kaydetme işlemleri yapılabilir
    // Örneğin: API call, Redux store update vb.
    
    // Financial Budget sayfasına yönlendirme
    navigate(<FinancialBudget/>);
  };

  return (
    <Box sx={{ position: 'relative', pb: 8 }}>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Kalemler</TableCell>
              {[1, 2, 3, 4, 5].map((year) => (
                <TableCell key={year} align="right">{`${year}.YIL`}</TableCell>
              ))}
              <TableCell align="right">TOPLAM</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow
                key={row.id}
                sx={{ 
                  '&:last-child td, &:last-child th': { border: 0 },
                  backgroundColor: row.isTotal ? '#f5f5f5' : 'inherit'
                }}
              >
                <TableCell 
                  component="th" 
                  scope="row"
                  sx={{ fontWeight: row.isTotal ? 'bold' : 'normal' }}
                >
                  {row.label}
                </TableCell>
                {row.values.map((value, colIndex) => (
                  <TableCell key={colIndex} align="right">
                    {row.isTotal ? (
                      <strong>{value.toLocaleString()}</strong>
                    ) : (
                      <TextField
                        type="number"
                        value={value === 0 ? '' : value}
                        onChange={(e) => handleValueChange(rowIndex, colIndex, e.target.value)}
                        
                        size="small"
                        inputProps={{ style: { textAlign: 'right', maxWidth: '100px' } }}
                      />
                    )}
                  </TableCell>
                ))}
                <TableCell align="right">
                  <strong>{calculateRowTotal(row.values).toLocaleString()}</strong>
                </TableCell>
              </TableRow>
            ))}
            <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
              <TableCell><strong>TOPLAM</strong></TableCell>
              {[0, 1, 2, 3, 4].map((colIndex) => (
                <TableCell key={colIndex} align="right">
                  <strong>{calculateColumnTotal(colIndex).toLocaleString()}</strong>
                </TableCell>
              ))}
              <TableCell align="right">
                <strong>
                  {rows
                    .reduce((acc, row) => acc + calculateRowTotal(row.values), 0)
                    .toLocaleString()}
                </strong>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Paper 
        sx={{ 
          mt: 2,
          p: 2,
          display: 'flex',
          justifyContent: 'flex-end',
          bgcolor: theme => alpha(theme.palette.primary.main, 0.03)
        }}
      >
       {/* <Button
          variant="contained"
          color="primary"
          onClick={handleSaveAndContinue}
          endIcon={<NavigateNextIcon />}
          sx={{
            px: 4,
            py: 1.5,
            borderRadius: 2,
            boxShadow: 3
          }}
        >
          Kaydet ve İlerle
          
        </Button>
        */}
      </Paper>
    </Box>
  );
};

export default FinancialTable;